const PAGES = {
  DashboardPage: {
    name: 'DashboardPage',
    title: 'Dashboard'
  },
  CirclesListingPage: {
    name: 'CirclesListingPage',
    title: 'Circles: Listing'
  },
  ShowCirclePage: {
    name: 'ShowCirclePage',
    title: 'Circle: Show'
  },
  EditCirclePage: {
    name: 'EditCirclePage',
    title: 'Circle: Edit'
  },
  NewCirclePage: {
    name: 'NewCirclePage',
    title: 'Circle: New'
  },
  ClustersListingPage: {
    name: 'ClustersListingPage',
    title: 'Clusters: Listing'
  },
  NewClusterPage: {
    name: 'NewClusterPage',
    title: 'Cluster: New'
  },
  ShowClusterPage: {
    name: 'ShowClusterPage',
    title: 'Cluster: Show'
  },
  EditClusterPage: {
    name: 'EditClusterPage',
    title: 'Cluster: Edit'
  },
  StatesListingPage: {
    name: 'StatesListingPage',
    title: 'States: Listing'
  },
  PincodesListingPage: {
    name: 'PincodesListingPage',
    title: 'PIN Codes: Listing'
  },
  NewPinCodePage: {
    name: 'NewPinCodePage',
    title: 'PinCodes: New'
  },
  EditPinCodePage: {
    name: 'EditPinCodePage',
    title: 'PinCodes: Edit'
  },
  CustomersListingPage: {
    name: 'CustomersListingPage',
    title: 'Customers: Listing'
  },
  FleetOwnerCustomersListing: {
    name: 'FleetOwnerCustomersListing',
    title: "FleetOwner's Customers: Listing"
  },
  FleetOwnersListingPage: {
    name: 'FleetOwnersListingPage',
    title: 'Fleet Owners: Listing'
  },
  ShowFleetOwnerPage: {
    name: 'ShowFleetOwnerPage',
    title: 'Fleet Owners: Show'
  },
  NewCustomerPage: {
    name: 'NewCustomerPage',
    title: 'Customers: New'
  },
  EditCustomerPage: {
    name: 'EditCustomerPage',
    title: 'Customers: Edit'
  },
  ShowCustomerPage: {
    name: 'ShowCustomerPage',
    title: 'Customers: Show'
  },
  DistributorsListingPage: {
    name: 'DistributorsListingPage',
    title: 'Distributor: Listing'
  },
  DistributorDetailsPage: {
    name: 'DistributorDetailsPage',
    title: 'Distributor: Details'
  },
  HeadUsersListingPage: {
    name: 'HeadUsersListingPage',
    title: 'Head Users: Listing'
  },
  NewHeadUserPage: {
    name: 'NewHeadUserPage',
    title: 'Head Users: New'
  },
  EditHeadUserPage: {
    name: 'EditHeadUserPage',
    title: 'Head Users: Edit'
  },
  MapHeadUserPage: {
    name: 'MapHeadUserPage',
    title: 'Head User: Map'
  },
  EditCpPage: {
    name: 'EditCpPage',
    title: 'CP: Edit'
  },
  BatteriesListingPage: {
    name: 'BatteriesListingPage',
    title: 'Battery: Listing'
  },
  BikesListingPage: {
    name: 'BikesListingPage',
    title: 'Bikes: Listing'
  },
  WarehousesListingPage: {
    name: 'WarehousesListingPage',
    title: 'Warehouses: Listing'
  },
  BatteryModelsListingPage: {
    name: 'BatteryModelsListingPage',
    title: 'Battery Model: Listing'
  },
  NewBatteryModelPage: {
    name: 'NewBatteryModelPage',
    title: 'Battery Model: New'
  },
  EditBatteryModelPage: {
    name: 'EditBatteryModelPage',
    title: 'Battery Model: Edit'
  },
  BatteryTransactionsListingPage: {
    name: 'BatteryTransactionsListingPage',
    title: 'Battery Transactions: Listing'
  },
  ChargingStationsListingPage: {
    name: 'ChargingStationsListingPage',
    title: 'Charging Stations Listing'
  },
  EarningsListingPage: {
    name: 'EarningsListingPage',
    title: 'Earnings: Listing'
  },
  PartnerBillingsListingPage: {
    name: 'PartnerBillingsListingPage',
    title: 'Partner Billings: Listing'
  },
  PartnerBillingsShowPage: {
    name: 'PartnerBillingsShowPage',
    title: 'Partner Billings: Show'
  },
  PerDayEarningShowPage: {
    name: 'PerDayEarningShowPage',
    title: 'Day Wise Swap Earning: Date'
  },
  ElectricityBillingsListingPage: {
    name: 'ElectricityBillingsListingPage',
    title: 'Electricity Billings: Listing'
  },
  ElectricityConfigsListingPage: {
    name: 'ElectricityConfigsListingPage',
    title: 'Electricity Configurations: Listing'
  },
  ElectricityServiceProvidersListingPage: {
    name: 'ElectricityServiceProvidersListingPage',
    title: 'Electricity Service Providers: Listing'
  },
  ElectricityClaimsListingPage: {
    name: 'ElectricityClaimsListingPage',
    title: 'Electricity Claims: Listing'
  },
  OffersListingPage: {
    name: 'OffersListingPage',
    title: 'Offers: Listing'
  },
  NewOfferPage: {
    name: 'NewOfferPage',
    title: 'Offers: New'
  },
  EditOfferPage: {
    name: 'EditOfferPage',
    title: 'Offers: Edit'
  },
  PermissionsConfigPage: {
    name: 'PermissionsConfigPage',
    title: 'Permissions Config: Page'
  },
  CrmUsersListingPage: {
    name: 'CrmUsersListingPage',
    title: 'CRM Users: Listing'
  },
  NewCrmUserPage: {
    name: 'NewCrmUserPage',
    title: 'CRM Users: New'
  },
  EditCrmUserPage: {
    name: 'EditCrmUserPage',
    title: 'CRM Users: Edit'
  },
  WorkOrdersListingPage: {
    name: 'WorkOrdersListingPage',
    title: 'Work Orders: Listing'
  },
  ShowWorkOrdersPage: {
    name: 'ShowWorkOrdersPage',
    title: 'Work Orders: Show'
  },
  SchemesListingPage: {
    name: 'SchemesListingPage',
    title: 'Schemes: Listing'
  },
  NewSchemePage: {
    name: 'NewSchemePage',
    title: 'Scheme: New'
  },
  EditSchemePage: {
    name: 'EditSchemePage',
    title: 'Schemes: Edit'
  },
  SecurityAmountsListingPage: {
    name: 'SecurityAmountsListingPage',
    title: 'Security Amounts: Listing'
  },
  NewSecurityAmountPage: {
    name: 'NewSecurityAmountPage',
    title: 'Security Amount: New'
  },
  EditSecurityAmountPage: {
    name: 'EditSecurityAmountPage',
    title: 'Security Amount: Edit'
  },
  AddonsListingPage: {
    name: 'AddonsListingPage',
    title: 'Addons: Listing'
  },
  NewAddonPage: {
    name: 'NewAddonPage',
    title: 'Addons: New'
  },
  EditAddonPage: {
    name: 'EditAddonPage',
    title: 'Addons: Edit'
  },
  OfferAddonsListingPage: {
    name: 'OfferAddonsListingPage',
    title: 'Offer Addons: Listing'
  },
  NewOfferAddonPage: {
    name: 'NewOfferAddonPage',
    title: 'Offer Addons: New'
  },
  EditOfferAddonPage: {
    name: 'EditOfferAddonPage',
    title: 'Offer Addons: Edit'
  },
  ServiceCentersListingPage: {
    name: 'ServiceCentersListingPage',
    title: 'Service Centers: Listing'
  },
  NewServiceCenterPage: {
    name: 'NewServiceCenterPage',
    title: 'Service Center: New'
  },
  EditServiceCenterPage: {
    name: 'EditServiceCenterPage',
    title: 'Service Center: Edit'
  },
  ShowServiceCenterPage: {
    name: 'ShowServiceCenterPage',
    title: 'Service Center: Show'
  },
  ComplaintCategoriesListingPage: {
    name: 'ComplaintCategoriesListingPage',
    title: 'Complaint Categories: Listing'
  },
  NewComplaintCategoryPage: {
    name: 'NewComplaintCategoryPage',
    title: 'Complaint Categories: New'
  },
  EditComplaintCategoryPage: {
    name: 'EditComplaintCategoryPage',
    title: 'Complaint Categories: Edit'
  },
  TallyTransactionsListingPage: {
    name: 'TallyTransactionsListingPage',
    title: 'Tally Transactions: Listing'
  },
  GeneralReportsListingPage: {
    name: 'GeneralReportsListingPage',
    title: 'General Reports: Listing'
  },
  WalletCashbacksListingPage: {
    name: 'WalletCashbacksListingPage',
    title: 'Wallet Cashbacks: Listing'
  },
  UploaderHistoryListingPage:{
    name: 'UploaderHistoryListingPage',
    title: 'Uploader History Listing'
  },
  RfidCardsListingPage: {
    name: 'RfidCardsListingPage',
    title: 'Voltup ID Cards (Rfids): Listing'
  },
  ChallansListingPage: {
    name: 'ChallansListingPage',
    title: 'Challans: Listing'
  },
  UploadFilesPage: {
    name: 'UploadFilesPage',
    title: 'Upload Files'
  },
  VehiclesListingPage: {
    name: 'VehiclesListingPage',
    title: 'Vehicles: Listing'
  },
  VehicleTypesListingPage: {
    name: 'VehicleTypesListingPage',
    title: 'Vehicle Types: Listing'
  },
  InspectionsItemsPage: {
    name: 'InspectionsItemsPage',
    title: 'Inspection Items'
  },
  RentalBookingsPage: {
    name: 'RentalBookingsPage',
    title: 'Rental Bookings: Listing'
  },
  AssetEarningsConfigPage: {
    name: 'AssetEarningsConfigPage',
    title: 'Rental Earnings Configurations: Listing'
  },
  WalletTransactionsListingPage: {
    name: 'WalletTransactionsListingPage',
    title: 'Wallet Transactions: Listing'
  },
  RentalCustomersPage: {
    name: 'RentalCustomersPage',
    title: 'Rental Customers: Listing'
  },
  ShowRentalCustomerPage: {
    name: 'ShowRentalCustomerPage',
    title: 'Rental Customers: Show'
  },
  LeaseOfferListingTab: {
    name: 'LeaseOfferListingTab',
    title: 'LeaseOfferListing: Tab'
  },
  NewLeaseOfferPage: {
    name: 'NewLeaseOfferPage',
    title: 'Lease Offer: New'
  },
  EditLeaseOfferPage: {
    name: 'EditLeaseOfferPage',
    title: 'Lease Offer: Edit'
  },
  RolloverConfigsPage: {
    name: 'RolloverConfigsPage',
    title: 'Lease Offers: Rollover Configurations'
  },
  NewRollOverConfigPage: {
    name: 'NewRollOverConfigPage',
    title: 'RollOver Configuartion: New'
  },
  EditRollOverConfigPage: {
    name: 'EditRollOverConfigPage',
    title: 'RollOver Configuartion: Edit'
  },
  LeadsListingPage: {
    name: 'LeadsListingPage',
    title: 'Leads: Listing'
  },
  LeadsEarningConfigsPage: {
    name: 'LeadsEarningConfigsPage',
    title: 'Leads Earning Config: Listing'
  },
  NewLeadsEarningConfigsPage: {
    name: 'NewLeadsEarningConfigsPage',
    title: 'Leads Earning Config: New'
  },
  EditLeadsEarningConfigsPage: {
    name: 'EditLeadsEarningConfigsPage',
    title: 'Leads Earning Config: Edit'
  },
  ServiceTypeMappingPage: {
    name: 'ServiceTypeMappingPage',
    title: 'Service Type Mapping: Listing'
  },
  NewServiceTypeMappingPage: {
    name: 'NewServiceTypeMappingPage',
    title: 'Service Type Mapping: New'
  },
  VoltUpAllocationKitListingPage: {
    name: 'VoltUpAllocationKitListingPage',
    title: 'VoltUp Allocation Kit: Listing'
  },
  NewVoltUpAllocationKitPage: {
    name: 'NewVoltUpAllocationKitPage',
    title: 'VoltUp Allocation Kit: New'
  },
  EditVoltUpAllocationKitPage: {
    name: 'EditVoltUpAllocationKitPage',
    title: 'VoltUp Allocation Kit: Edit'
  },
  VoltUpAllocationKitReportsListingPage: {
    name: 'VoltUpAllocationKitReportsListingPage',
    title: 'VAK Reports: Listing'
  },
  VoltUpAllocationKitTransactionsListingPage: {
    name: 'VoltUpAllocationKitTransactionsListingPage',
    title: 'VoltUp Allocation Kit Transactions: Listing'
  },
  ChargingZonesMapPage:{
    name: 'ChargingZonesMapPage',
    title: 'Charging Zone Map'
  },
  ChargingStationDiagnosticsPage: {
    name: 'ChargingStationDiagnosticsPage',
    title: 'CS Diagnostics'
  },
  ChargingStationVersionUpdatePage: {
    name: 'ChargingStationVersionUpdatePage',
    title: 'CS Version Update'
  },
  SearchUserPage: {
    name: 'SearchUserPage',
    title: 'Search User: Page'
  },
  SupportPage: {
    name: 'SupportPage',
    title: 'Support'
  },
  NewTechnicianPage: {
    name: 'NewTechnicianPage',
    title: 'Technician: New'
  },
  EditTechnicianPage: {
    name: 'EditTechnicianPage',
    title: 'Technician: Edit'
  },
  NewCoordinatorPage: {
    name: 'NewCoordinatorPage',
    title: 'Coordinator: New'
  },
  EditCoordinatorPage: {
    name: 'EditCoordinatorPage',
    title: 'Coordinator: Edit'
  },
  TransactionOrdersPage: {
    name: 'TransactionOrdersPage',
    title: 'Transaction Order'
  },
  OperationsPage: {
    name: 'OperationsPage',
    title: 'Operations: All'
  },
}

export default PAGES;
